module.exports = __webpack_public_path__ + "img/fron-03.fdbae9ad.jpg";